import { Booking } from '../../core/models/booking';
import { extractMessageFromError } from '../../infra/adapters/luminara/common/ErrorUtil';

export interface ScheduleBookingAsClientState {
  booking?: Booking;
  bookingUrl?: string;
  loadingDataErrors: any[];
}

export const initialScheduleBookingAsClientState = () => {
  return { loadingDataErrors: [] } as ScheduleBookingAsClientState;
};

export interface ScheduleBookingAsClientAction {
  type: 'BOOKING_SUCCESSFULLY_SCHEDULED' | 'BOOKING_SCHEDULING_FAILURE' | 'HEALER_SCHEDULING_URL_LOADED_SUCCESSFULLY' | 'HEALER_SCHEDULING_URL_LOAD_FAILURE';
  payload?: any;
}

const ScheduleBookingAsClientReducer = (
  state: ScheduleBookingAsClientState = initialScheduleBookingAsClientState(),
  action: ScheduleBookingAsClientAction
): ScheduleBookingAsClientState => {
  switch (action.type) {
    case 'BOOKING_SUCCESSFULLY_SCHEDULED': {
      return { ...state, booking: action.payload, loadingDataErrors: [] };
    }
    case 'BOOKING_SCHEDULING_FAILURE': {
      return { ...state, booking: undefined, loadingDataErrors: state.loadingDataErrors.concat(extractMessageFromError(action.payload)) };
    }
    case 'HEALER_SCHEDULING_URL_LOADED_SUCCESSFULLY': {
      return { ...state, bookingUrl: action.payload as string, loadingDataErrors: [] };
    }
    case 'HEALER_SCHEDULING_URL_LOAD_FAILURE': {
      return { ...state, bookingUrl: undefined, loadingDataErrors: state.loadingDataErrors.concat(extractMessageFromError(action.payload)) };
    }
    default:
      return state;
  }
};

export default ScheduleBookingAsClientReducer;
